import { FC, ReactNode, useState } from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { cn } from 'lib/utils';
import { uiCheckbox } from '../CutCorners';

interface BPCheckboxProps {
  id: string;
  children: ReactNode;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const BPCheckbox: FC<BPCheckboxProps> = ({
  id,
  children,
  onChange = () => {},
  disabled = false,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleChange = (checked: boolean) => {
    onChange && onChange(checked);
    setIsChecked(checked);
  };

  return (
    <div className="inline-grid relative grid-cols-[auto_1fr] gap-5 justify-start items-start">
      <Checkbox
        id={id}
        className="z-10"
        onCheckedChange={handleChange}
        disabled={disabled}
      />
      <Label htmlFor={id} className="text-[18px] font-normal z-10 self-center">
        {children}
      </Label>
      <Background isChecked={isChecked} />
    </div>
  );
};

const Background: FC<{ isChecked: boolean }> = ({ isChecked }) => (
  <>
    <div
      className={cn(
        'block absolute w-[40px] h-[40px] backdrop-blur-md transition-background-color duration-100 ease-in-out',
        isChecked ? 'bg-white/[0.08]' : 'bg-white/[0.05]',
        uiCheckbox.bg
      )}
    />
    <div
      className={cn(
        'block absolute top-0 left-0 w-[40px] h-[40px] pointer-events-none bg-gradient-to-b transition-background-color duration-100 ease-in-out',
        isChecked
          ? 'from-bionic-green/50 to-bionic-green/20'
          : 'from-white/30 to-white/10',
        'peer-focus-visible:from-white peer-focus-visible:to-white',
        uiCheckbox.border
      )}
    />
  </>
);

export default BPCheckbox;
